<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="collapse"
            background-color="#324157"
            text-color="#bfcbd9"
            active-text-color="#20a0ff"
            unique-opened
            :router="false"
        >
            <template v-for="(item, item_index) in menus">
                <template v-if="item.sub_menu.length > 0">
                    <el-submenu :index="item.path_name" :key="item_index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="(subItem, subItem_index) in item.sub_menu">
                            <el-submenu
                                v-if="subItem.type !=2 && subItem.sub_menu.length > 0"
                                :index="subItem.path_name"
                                :key="subItem_index"
                            >
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item
                                    v-for="(threeItem,i) in subItem.sub_menu"
                                    :key="i"
                                    :index="threeItem.path_name"
                                    @click="toLink(threeItem)"
                                >{{ threeItem.title }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item
                                v-else
                                :index="subItem.path_name"
                                :key="subItem_index"
                                @click="toLink(subItem)"
                            >{{ subItem.title }}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.path_name" :key="item_index" @click="toLink(item)">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from '../common/bus';
import http from '../../api/manageApiConfig'
export default {
    data() {
        return {
            collapse: false,
            items: [
                {
                    icon: 'el-icon-lx-home',
                    index: 'index',
                    title: '控制台'
                },
                {
                    icon: 'el-icon-lx-menu',
                    index: 'menumanage',
                    title: '菜单管理'
                },
                {
                    icon: 'el-icon-lx-profile',
                    index: 'rolemanage',
                    title: '角色管理'
                },
                {
                    icon: 'el-icon-lx-profile',
                    index: 'accountmanage',
                    title: '账号管理'
                },
                {
                    icon: 'el-icon-lx-people',
                    index: 'usersmanage',
                    title: '用户管理',
                    subs: [
                        {
                            index: 'userslist',
                            title: '用户列表'
                        }
                    ]
                },
                {
                    icon: 'el-icon-lx-profile',
                    index: 'doctormanage',
                    title: '医生管理',
                    subs: [
                        {
                            index: 'doctorlist',
                            title: '医生列表'
                        },
                        {
                            index: 'doctorreviewlist',
                            title: '审核列表'
                        },
                        {
                            index: 'prescriptionmanage',
                            title: '药方管理'
                        }
                    ]
                },
                {
                    icon: 'el-icon-lx-service',
                    index: 'operationmanage',
                    title: '运营管理',
                    subs: [
                        {
                            index: 'pushmanage',
                            title: '推送管理',
                            subs: [
                                {
                                    index: 'pushlist',
                                    title: '推送列表'
                                }
                            ]
                        },
                        {
                            index: 'msgmanage',
                            title: '短信管理',
                            subs: [
                                {
                                    index: 'msglist',
                                    title: '短信列表'
                                },
                                {
                                    index: 'msgsend',
                                    title: '每日发送'
                                },
                                {
                                    index: 'applist',
                                    title: '应用列表'
                                }
                            ]
                        },
                        {
                            index: 'searchmanage',
                            title: '搜索管理'
                        },
                        {
                            index: 'ordermanage',
                            title: '订单管理'
                        },
                        {
                            index: 'apkmanage',
                            title: '安装包管理'
                        },
                        {
                            index: 'couponmanage',
                            title: '优惠卷配置'
                        },
                        {
                            index: 'editormanage',
                            title: '协议管理'
                        },
                        {
                            index: 'bannermanage',
                            title: 'banner管理'
                        },
                        {
                            index: 'pagemanage',
                            title: '发现页管理'
                        },
                        {
                            index: 'feedbackmanage',
                            title: '意见反馈'
                        },
                        {
                            index: 'newsmanage',
                            title: '要闻所有分类管理'
                        }
                    ]
                },
                // {
                //     icon: 'el-icon-lx-emoji',
                //     index: 'icon',
                //     title: '自定义图标'
                // }
                // {
                //     icon: 'el-icon-lx-cascades',
                //     index: 'table',
                //     title: '基础表格'
                // },
                // {
                //     icon: 'el-icon-lx-copy',
                //     index: 'tabs',
                //     title: 'tab选项卡'
                // },
                // {
                //     icon: 'el-icon-lx-calendar',
                //     index: '3',
                //     title: '表单相关',
                //     subs: [
                //         {
                //             index: 'form',
                //             title: '基本表单'
                //         },
                //         {
                //             index: '3-2',
                //             title: '三级菜单',
                //             subs: [
                //                 {
                //                     index: 'editor',
                //                     title: '富文本编辑器'
                //                 },
                //                 {
                //                     index: 'markdown',
                //                     title: 'markdown编辑器'
                //                 }
                //             ]
                //         },
                //         {
                //             index: 'upload',
                //             title: '文件上传'
                //         }
                //     ]
                // },
                // {
                //     icon: 'el-icon-lx-emoji',
                //     index: 'icon',
                //     title: '自定义图标'
                // },
                // {
                //     icon: 'el-icon-pie-chart',
                //     index: 'charts',
                //     title: 'schart图表'
                // },
                // {
                //     icon: 'el-icon-rank',
                //     index: '6',
                //     title: '拖拽组件',
                //     subs: [
                //         {
                //             index: 'drag',
                //             title: '拖拽列表'
                //         },
                //         {
                //             index: 'dialog',
                //             title: '拖拽弹框'
                //         }
                //     ]
                // },
                // {
                //     icon: 'el-icon-lx-global',
                //     index: 'i18n',
                //     title: '国际化功能'
                // },
                // {
                //     icon: 'el-icon-lx-warn',
                //     index: '7',
                //     title: '错误处理',
                //     subs: [
                //         {
                //             index: 'permission',
                //             title: '权限测试'
                //         },
                //         {
                //             index: '404',
                //             title: '404页面'
                //         }
                //     ]
                // },
                // {
                //     icon: 'el-icon-lx-redpacket_fill',
                //     index: '/donate',
                //     title: '支持作者'
                // }
            ],
            menus: []
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        this.getData();
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
    },
    methods: {
        getData() {
            let that = this;
            let params = {
                role_id: localStorage.getItem('ms_role')
            }
            http.get("/admin/menus",{params: params}).then(function(res) {
                that.menus = res.data;
            });
        },
        toLink(item){
          console.log(item)
            window.location.href = item.url + '?t=1'+`&token=`+localStorage.getItem('ms_token');
        }
    }
};
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 250px;
}
.sidebar > ul {
    height: 100%;
}
</style>
